module.exports=function(scope){ return `{"data":{"isRunning":true,"version":"8.x.x"},"meta":{"code":200,"ok":true,"message":"Server is running!"}}`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/test-connection.json.tpl